Vue.component('nav-bar-footer', {
  template: '#nav-bar-footer',
  data: function () {
    return {
      kontakt: [],
      navElements: []
    }
  },
  created: function () {
    this.getList();
  },
  mounted: function () {
    const currentYear = new Date().getFullYear();
    $('#copyright').html('&copy; N-Sykon ' + currentYear);
  },
  methods: {
    getList: function () {
      const self = this;
      $.post("/back/NavFooter.php", null, function (result, textStatus) {
        if (typeof result.kontakt !== 'undefined' && result.kontakt !== null) {
          self.kontakt = JSON.parse(result.kontakt);

          if (self.kontakt.fb === undefined) self.kontakt.fb = '';
          if (self.kontakt.ig === undefined) self.kontakt.ig = '';
          if (self.kontakt.tw === undefined) self.kontakt.tw = '';
          if (self.kontakt.yt === undefined) self.kontakt.yt = '';
        }
        if (typeof result.navElements !== 'undefined' && result.navElements !== null) {
          self.navElements = result.navElements;
        }
      }, "json");
    }
  }
});
